var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 550 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-35,.cls-58,.cls-77,.cls-78{fill:none;}.cls-2{fill:#b2d4ff;}.cls-3{fill:#f17b6b;}.cls-4{opacity:0.5;}.cls-5{fill:#eae6ff;}.cls-6{fill:#fff;}.cls-7{fill:#dfe1e5;}.cls-8{fill:#c0b6f2;}.cls-9{fill:#eff7ff;}.cls-10{fill:#9cb4db;}.cls-11{fill:#31cbff;}.cls-12{fill:url(#linear-gradient);}.cls-13{fill:#4b4c4c;opacity:0.29;}.cls-14{fill:url(#linear-gradient-2);}.cls-15{fill:url(#linear-gradient-3);}.cls-16{fill:url(#linear-gradient-4);}.cls-17{fill:url(#linear-gradient-5);}.cls-18{fill:url(#linear-gradient-6);}.cls-19{fill:url(#linear-gradient-7);}.cls-20{fill:url(#linear-gradient-8);}.cls-21{fill:url(#linear-gradient-9);}.cls-22{fill:url(#linear-gradient-10);}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{fill:url(#linear-gradient-13);}.cls-26{fill:url(#linear-gradient-14);}.cls-27{fill:#bbcbff;}.cls-27,.cls-28,.cls-29{fill-rule:evenodd;}.cls-28{fill:#c7d4ff;fill-opacity:0.3;}.cls-29{fill:url(#linear-gradient-15);}.cls-30{fill:url(#linear-gradient-16);}.cls-31{fill:#cd6161;}.cls-32{fill:url(#linear-gradient-17);}.cls-33{fill:url(#linear-gradient-18);}.cls-34{fill:#fcc;}.cls-35{stroke:#2b2e40;stroke-width:2.69px;}.cls-35,.cls-58,.cls-77,.cls-78{stroke-linecap:round;stroke-linejoin:round;}.cls-36{fill:#344563;}.cls-37{fill:#00e7ff;}.cls-38{fill:#e68181;}.cls-39{fill:#303048;}.cls-40{fill:#2b2e40;}.cls-41{fill:#505f79;}.cls-42{fill:url(#linear-gradient-19);}.cls-43{fill:url(#linear-gradient-20);}.cls-44{fill:#303047;}.cls-45{clip-path:url(#clip-path);}.cls-46{fill:#0cf;}.cls-47{fill:#67ffcc;}.cls-48{clip-path:url(#clip-path-2);}.cls-49{clip-path:url(#clip-path-3);}.cls-50{fill:url(#linear-gradient-21);}.cls-51{fill:#88acff;}.cls-52{clip-path:url(#clip-path-4);}.cls-53{fill:#f2edf2;}.cls-54{fill:url(#linear-gradient-22);}.cls-55{fill:url(#linear-gradient-23);}.cls-56{fill:url(#linear-gradient-24);}.cls-57{opacity:0.49;}.cls-58{stroke:#303048;stroke-width:2.17px;}.cls-59{fill:#f66;}.cls-60{fill:#f96;}.cls-61{fill:#e86456;}.cls-62{clip-path:url(#clip-path-5);}.cls-63{fill:#1f2231;}.cls-64{fill:#454d6a;}.cls-65{clip-path:url(#clip-path-6);}.cls-66{fill:#25293a;}.cls-67{clip-path:url(#clip-path-7);}.cls-68{fill:url(#linear-gradient-25);}.cls-69{clip-path:url(#clip-path-8);}.cls-70{fill:#232048;}.cls-71{fill:#232638;}.cls-72{fill:#21304a;}.cls-73{fill:url(#linear-gradient-26);}.cls-74{clip-path:url(#clip-path-9);}.cls-75{clip-path:url(#clip-path-10);}.cls-76{fill:#998dd9;}.cls-77{stroke:#998dd9;}.cls-77,.cls-78{stroke-width:9.4px;}.cls-78{stroke:#c0b6f2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 231.34,
    y1: 261.03,
    x2: 344.93,
    y2: 302.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aec4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7896ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 163.29,
    y1: 199.45,
    x2: 378.38,
    y2: 201.6,
    gradientTransform: "translate(-30.97 41.79) rotate(-9.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 183.79,
    y1: 172.21,
    x2: 279.58,
    y2: 172.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1c7d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfe1e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 181.45,
    y1: 183.78,
    x2: 261.39,
    y2: 183.78,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 179.11,
    y1: 198.5,
    x2: 274.91,
    y2: 198.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 176.77,
    y1: 211.83,
    x2: 272.58,
    y2: 211.83,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 174.44,
    y1: 222.71,
    x2: 242.22,
    y2: 222.71,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 353.95,
    y1: 262.72,
    x2: 471.89,
    y2: 302.43,
    gradientTransform: "translate(0.3 -0.44) rotate(0.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fcfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f4f9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e6f1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d1e5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#b7d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2d4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 350.76,
    y1: 248.43,
    x2: 447.91,
    y2: 248.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c7d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 350.7,
    y1: 261.6,
    x2: 431.73,
    y2: 261.6,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 350.7,
    y1: 275.14,
    x2: 447.84,
    y2: 275.14,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 348.1,
    y1: 369.46,
    x2: 463.43,
    y2: 369.46,
    gradientTransform: "translate(0.4 -0.44) rotate(0.06)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 405.3,
    y1: 392.76,
    x2: 406.81,
    y2: 294.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3bcd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79a6cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 404.7,
    y1: 214.09,
    x2: 406.22,
    y2: 115.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b8ab8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 412.83,
    y1: 158.45,
    x2: 412.83,
    y2: 205.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffddce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 76.49,
    y1: 344.85,
    x2: 301.68,
    y2: 344.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe5746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee9aeb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 148.85,
    y1: 246.28,
    x2: 144.36,
    y2: 458,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 181.49,
    y1: 302.13,
    x2: 71.38,
    y2: 428.55,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -5178.3,
    y1: 364.51,
    x2: -5178.3,
    y2: 313.08,
    gradientTransform: "matrix(1, 0, 0, -1, 5658.76, 657.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77a6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5cdff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 466.21,
    y1: 493.6,
    x2: 466.21,
    y2: 283.22,
    gradientTransform: "translate(932.42 657.78) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#589db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#64a4ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#94bdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bad2dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#d5e0e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e5e9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebecf0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.43,331.18h7.29a1.52,1.52,0,0,0,1.5-1.29l1.41-9.42H448.51l1.42,9.42A1.52,1.52,0,0,0,451.43,331.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472,331.18h7.29a1.52,1.52,0,0,0,1.5-1.29l1.42-9.42H469.06l1.42,9.42A1.51,1.51,0,0,0,472,331.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M464.57,497.66a.26.26,0,0,1,.25.19c.37,1.31,2.54,9,2.64,10.47s0,11.68,0,11.68H428.72s-1.91-10.11,8.42-11.68,11.84-6,12.1-9.5a30.1,30.1,0,0,0,0-5.43s4.41-1,5.64,1c.37.6.69,1.15.95,1.62a3.51,3.51,0,0,0,3.16,1.8Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -5165.36,
    y1: 518.03,
    x2: -5126.43,
    y2: 518.03,
    gradientTransform: "matrix(-1, 0, 0, 1, -4697.85, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M497.69,497.66a.27.27,0,0,1,.26.19c.37,1.31,2.53,9,2.64,10.47s0,11.68,0,11.68H461.85s-1.91-10.11,8.42-11.68,11.84-6,12.1-9.5a30.1,30.1,0,0,0,0-5.43s4.4-1,5.64,1c.37.6.68,1.15.95,1.62a3.51,3.51,0,0,0,3.15,1.8Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -5198.48,
    y1: 518.03,
    x2: -5159.55,
    y2: 518.03,
    gradientTransform: "matrix(-1, 0, 0, 1, -4697.85, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -5180.89,
    y1: 449.43,
    x2: -5180.89,
    y2: 377.35,
    gradientTransform: "matrix(1, 0, 0, -1, 5665.54, 781.9)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 463.62,
    y1: 509.85,
    x2: 463.62,
    y2: 374.64,
    gradientTransform: "translate(928.9 801.19) rotate(179.76)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.67,231.73a157.6,157.6,0,0,1-24.54,10.33c-4,1.19-6.63,3.1-10.43,1.24a18,18,0,0,1-5-4.08c-6.14-6.64-14.38-23.7-16.23-27.62a1,1,0,0,1,.35-1.32l6.71-4.7a1.07,1.07,0,0,1,1.48.26c1.38,1.95,5.07,7.17,10.29,14.79a68.77,68.77,0,0,0,4.11,5.52,24.17,24.17,0,0,0,2.73,2.87,2.76,2.76,0,0,0,3,.34c11.85-6.15,19.54-10.86,22.79-12.92.12-.08.24-.16.37-.23A52.26,52.26,0,0,1,340.67,231.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.76,403.68l.05,2.07-26.6.62a9.39,9.39,0,0,1-.22-2.06c0-2,.66-4.89,4.18-5.72,5.59-1.31,9.95-4.67,9.38-16.19,0,0,5.29-1.3,4.53,4l7.1-.17a51.36,51.36,0,0,0,1.38,8.84C322.3,397.38,321.76,403.68,321.76,403.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.87,381a1,1,0,0,1-.95-.73c-.68-2.59-1.09-5.32-1.59-7.94q-.93-4.92-1.71-9.87-1.53-9.72-2.49-19.54c-1.9-19.57-.19-38.27,7.57-56.49,1.94-4.57,6.09-14.9,12.29-13.3,4.19,1.07,5.59,6.76,5.82,10.44.69,10.73-.35,21.48-1.75,32.11-.9,6.89-2.12,13.74-2.59,20.67s.26,13.69,1.08,20.55l1.37,11.45c.43,3.57,1.24,7.34,1.38,11a1,1,0,0,1-.89,1C322.09,380.51,310.9,380.88,307.87,381Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 313.96,
    y1: 273.16,
    x2: 313.38,
    y2: 363.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#232738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161b2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.6,219.08c-.6,3.81-2.16,12.68-5.4,25.63a2.73,2.73,0,0,1-2.26,2c-1.7.24-4.88.31-10.81-.43-9.17-1.13-15.52-1.82-17.91-2.08a1.07,1.07,0,0,0-1.16.94l-.92,8.14a1.05,1.05,0,0,0,.75,1.14c4.16,1.2,22.4,6.33,31.44,6.12,10.25-.24,10-4.5,12.37-9.69s9.55-24.13,9.64-33.2c.07-6.57-5.94-8.53-10.8-5.81A10,10,0,0,0,313.6,219.08Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 204.44,
    y1: 412.64,
    x2: 207.09,
    y2: 361.81,
    gradientTransform: "translate(102.34 -181.41) rotate(-2.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#585590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3873"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.55,396.6l.59,2-25.52,7.53a9.06,9.06,0,0,1-.75-1.94c-.52-1.94-.64-4.89,2.54-6.61,5.06-2.72,8.39-7.09,4.84-18.07,0,0,4.77-2.64,5.43,2.72l6.8-2a51,51,0,0,0,3.65,8.17C367.43,390.38,368.55,396.6,368.55,396.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.41,294.47c0,.29.12.62.22,1a20,20,0,0,0,3.75,7.28c3.89,4.91,10.74,7.41,11.76,14.19a133.2,133.2,0,0,0,7.29,27.22q3.51,9.33,7.59,18.44,2.06,4.63,4.27,9.19c1.17,2.43,2.3,5,3.65,7.34a1,1,0,0,0,1.12.46c2.94-.87,13.77-4.17,16.95-5.3a1,1,0,0,0,.61-1.21c-1.09-3.5-2.88-7-4.24-10.35q-2.17-5.42-4.36-10.82c-2.61-6.48-5.11-12.91-6.47-19.79-1.14-5.71-1.83-11.48-2.54-17.25a322.67,322.67,0,0,0-5.83-35.21c.28,1.16-3.85,3.23-4.65,3.51-2.22.79-4.67,1.14-6.95,1.75a87.21,87.21,0,0,0-11.14,3.73,24.91,24.91,0,0,0-3.51,1.74,14.22,14.22,0,0,1-4.16,1.26C308.17,292.23,307,292.16,307.41,294.47Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cobra id pages_trello_right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    className: "cls-5",
    x: 21.26,
    y: 126.41,
    width: 126.55,
    height: 127.95,
    rx: 3.71,
    transform: "translate(-0.21 0.09) rotate(-0.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options",
    className: "cls-2",
    cx: 139.26,
    cy: 135.03,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-2",
    "data-name": "Options",
    className: "cls-2",
    cx: 130.77,
    cy: 135.07,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-3",
    "data-name": "Options",
    className: "cls-2",
    cx: 122.28,
    cy: 135.11,
    r: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.65,138.62h0l-44.41-.21a3.06,3.06,0,0,1,0-6.12h0l44.41.21a3.06,3.06,0,0,1,0,6.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Card",
    className: "cls-6",
    x: 27.22,
    y: 147.2,
    width: 114.73,
    height: 84.69,
    rx: 4.6,
    transform: "matrix(1, 0, 0, 1, -0.21, 0.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.9,164a3.06,3.06,0,0,1,0-6.12l91-.09h0a3.06,3.06,0,0,1,0,6.12l-91,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.83,177.21a3.06,3.06,0,1,1,0-6.12l74.91-.18h0a3.06,3.06,0,1,1,0,6.12l-74.91.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.83,217.82a3.06,3.06,0,0,1,0-6.12l62.58-.19h0a3.06,3.06,0,0,1,0,6.12l-62.57.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add_Card",
    "data-name": "Add Card"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.78,245a3.06,3.06,0,0,1,0-6.12l29.52,0h0a3.06,3.06,0,0,1,0,6.12l-29.52,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "list-2",
    "data-name": "list"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M325.46,340.07a4.82,4.82,0,0,1-4.82,4.83l-116.9.13a4.84,4.84,0,0,1-4.83-4.82l-.22-207.42a4.82,4.82,0,0,1,4.82-4.83l116.9-.13a4.84,4.84,0,0,1,4.83,4.82l0,20.36.09,85.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add_Card-2",
    "data-name": "Add Card"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.32,335.66a3.06,3.06,0,0,1,0-6.12l29.52,0h0a3.06,3.06,0,0,1,0,6.12l-29.52,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Card-2",
    "data-name": "Card",
    className: "cls-8",
    x: 204.71,
    y: 148.68,
    width: 114.73,
    height: 84.69,
    rx: 4.6,
    transform: "matrix(1, 0, 0, 1, -0.21, 0.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Card-3",
    "data-name": "Card",
    className: "cls-9",
    x: 204.71,
    y: 237.78,
    width: 114.73,
    height: 84.69,
    rx: 4.6,
    transform: "matrix(1, 0, 0, 1, -0.3, 0.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M210.39,251.58a3.06,3.06,0,0,1,0-6.12l91-.08h0a3.06,3.06,0,1,1,0,6.11l-91,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M210.32,264.8a3.06,3.06,0,0,1,0-6.12l74.91-.19h0a3.06,3.06,0,0,1,0,6.12l-74.92.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M210.32,278.33a3.06,3.06,0,0,1,0-6.12l91-.19h0a3.06,3.06,0,0,1,0,6.12l-91,.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 207.27,
    y: 310.76,
    width: 24.16,
    height: 9.28,
    rx: 3.24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-4",
    "data-name": "Options",
    className: "cls-2",
    cx: 317,
    cy: 136.51,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-5",
    "data-name": "Options",
    className: "cls-2",
    cx: 308.51,
    cy: 136.55,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-6",
    "data-name": "Options",
    className: "cls-2",
    cx: 300.02,
    cy: 136.59,
    r: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.39,140.11h0L208,139.9a3.06,3.06,0,0,1,0-6.12h0l44.41.21a3.06,3.06,0,0,1,0,6.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Card-4",
    "data-name": "Card",
    className: "cls-6",
    x: 204.63,
    y: 237.57,
    width: 114.89,
    height: 84.81,
    rx: 4.61,
    transform: "translate(-0.3 0.28) rotate(-0.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M210.54,317.4a3.07,3.07,0,0,1,0-6.13l43.5,0h0a3.07,3.07,0,1,1,0,6.13l-43.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M319.48,240.79l.08,65.22-89.36.09H204.67l-.08-65.21a3.28,3.28,0,0,1,3.28-3.29l108.33-.12A3.28,3.28,0,0,1,319.48,240.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M199.05,158.54a4.25,4.25,0,0,1,.94,0l104.71,13a4.61,4.61,0,0,1,4,5.14l-9.29,74.9a4.61,4.61,0,0,1-5.13,4l-95.15-11.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "card-5",
    "data-name": "card"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Card-6",
    "data-name": "Card",
    className: "cls-14",
    x: 168.97,
    y: 157.74,
    width: 114.73,
    height: 84.69,
    rx: 4.6,
    transform: "translate(37.68 -35.86) rotate(9.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M186.32,167.41a3.06,3.06,0,0,1,1.06-6L277.05,177h0a3.06,3.06,0,1,1-1.05,6l-89.68-15.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M184,180.42a3.06,3.06,0,0,1,1.05-6l73.82,12.75h0a3.06,3.06,0,0,1-1.05,6L184,180.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M181.64,193.75a3.06,3.06,0,0,1,1.05-6l89.68,15.52h0a3.06,3.06,0,1,1-1.05,6l-89.68-15.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M179.31,207.09a3.06,3.06,0,0,1,1.05-6L270,216.58h0a3.06,3.06,0,0,1-1.05,6l-89.68-15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M177,220.42a3.06,3.06,0,0,1,1.05-6L239.68,225h0a3.06,3.06,0,1,1-1.05,6L177,220.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "list-3",
    "data-name": "list"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG-2",
    "data-name": "BG",
    className: "cls-5",
    x: 342.29,
    y: 127.85,
    width: 126.55,
    height: 306.67,
    rx: 5.74,
    transform: "translate(-0.3 0.44) rotate(-0.06)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add_Card-3",
    "data-name": "Add Card"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.8,425.16a3.06,3.06,0,1,1,0-6.12l29.52,0h0a3.06,3.06,0,0,1,0,6.12l-29.51,0Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Options-7",
    "data-name": "Options",
    className: "cls-2",
    cx: 460.19,
    cy: 136.47,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-8",
    "data-name": "Options",
    className: "cls-2",
    cx: 451.7,
    cy: 136.51,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-9",
    "data-name": "Options",
    className: "cls-2",
    cx: 443.21,
    cy: 136.55,
    r: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M395.58,140.07h0l-44.41-.21a3.06,3.06,0,0,1,0-6.12h0l44.41.21a3.06,3.06,0,0,1,0,6.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Card-7",
    "data-name": "Card",
    className: "cls-20",
    x: 348.15,
    y: 237.74,
    width: 114.73,
    height: 84.69,
    rx: 4.6,
    transform: "matrix(1, 0, 0, 1, -0.3, 0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M353.82,251.54a3.06,3.06,0,1,1,0-6.12l91-.09h0a3.06,3.06,0,1,1,0,6.12l-91,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M353.76,264.75a3.06,3.06,0,0,1,0-6.12l74.92-.18h0a3.06,3.06,0,0,1,0,6.12l-74.91.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M353.76,278.29a3.06,3.06,0,1,1,0-6.12l91-.19h0a3.06,3.06,0,1,1,0,6.12l-91,.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Card-8",
    "data-name": "Card",
    className: "cls-24",
    x: 348.14,
    y: 326.93,
    width: 115.25,
    height: 85.07,
    rx: 4.62,
    transform: "translate(-0.4 0.44) rotate(-0.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M353.57,406a3.08,3.08,0,1,1,0-6.15l43.64,0h0a3.07,3.07,0,1,1,0,6.14l-43.64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M463.35,330.16l.07,65.42-89.64.09H348.17l-.07-65.41a3.29,3.29,0,0,1,3.29-3.3l108.66-.12A3.3,3.3,0,0,1,463.35,330.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Card-9",
    "data-name": "Card",
    className: "cls-6",
    x: 347.55,
    y: 148.26,
    width: 115.25,
    height: 85.07,
    rx: 4.62,
    transform: "translate(-0.21 0.44) rotate(-0.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M353,227.34a3.07,3.07,0,0,1,0-6.14l43.64,0h0a3.08,3.08,0,0,1,0,6.15l-43.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M462.75,151.49l.07,65.42-89.63.1H347.57l-.07-65.41a3.29,3.29,0,0,1,3.29-3.3l108.66-.12A3.29,3.29,0,0,1,462.75,151.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M405.23,182.09l-8.38,22.21a24.9,24.9,0,0,1-13.32-12.53L405.17,182Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M405.23,158.45v23.64l-.06-.05-21.64,9.73a22.43,22.43,0,0,1-2-9.68c0-.41,0-.83,0-1.24a22.59,22.59,0,0,1,6.84-15.42c.05,0,.08-.06.08-.09h0a22.72,22.72,0,0,1,16.67-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M396.85,204.3l8.38-22.21V158.45a24.13,24.13,0,0,1,8.42,1.44,23.5,23.5,0,0,1,8.25,5.45,22.38,22.38,0,0,1,6.88,15.58q0,.59,0,1.17a22.55,22.55,0,0,1-6.87,16.69h0a22.69,22.69,0,0,1-16.73,7A24.92,24.92,0,0,1,396.85,204.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sasquatch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arm",
    className: "cls-30",
    d: "M263,341.56l-.34,1.8h0c-.73,3.19-2.84,8.16-7.76,15.65,0,0-4.44,7.58-15.22,6.05a5.89,5.89,0,0,0-4.22,1c-4.63,3.25-17.15,11-32.94,12.05a52.89,52.89,0,0,1-8-.06A50.36,50.36,0,0,1,184,376a51.57,51.57,0,0,1-6.17-2.29l2.53-21.07,1.88-15.59s18.16,5.48,27.14,5.11a38.34,38.34,0,0,0,18.82-6.06c6.44-4.23,7.79-9.35,9.15-16.54A10,10,0,0,1,249,311.66l3.24.61a18.4,18.4,0,0,1,3,.56l3.5.66a5.35,5.35,0,0,1,4.26,6.24l-1.31,7-2.06,10.92.8.15A3.25,3.25,0,0,1,263,341.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow",
    className: "cls-31",
    d: "M202.49,378.1a52.89,52.89,0,0,1-8-.06A50.36,50.36,0,0,1,184,376c-.2-3.55-1.41-24.74-1.49-26.18C183.11,359.84,190.83,376.38,202.49,378.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body",
    className: "cls-32",
    d: "M187.6,437c-2.69,22.22-6.74,47.14-6.74,47.14l-2.69,10.1-28.29-4V490q-.09-4.44-.19-8.88l-.3-14.34-.12-5.6c0-.4,0-.81,0-1.22a4.17,4.17,0,0,1,.1-.77,3.19,3.19,0,0,0,.1-.69,4.53,4.53,0,0,0-.72.08l-.74.12a10.24,10.24,0,0,0-1.43.34,3.75,3.75,0,0,0-2.36,1.73,10.2,10.2,0,0,0-.81,2.6c-.33,1.4-.58,2.81-.8,4.24a109.54,109.54,0,0,0-.83,21.87l-35.69-2s-.66-12.22-1.09-24.35c0-.32,0-.64,0-.95-.12-3.34-.22-6.64-.28-9.65,0-.34,0-.67,0-1-.09-4.58-.08-8.4.08-10.52l.67-121.9s-1.34-36.37,0-47.14,10.21-19.39,19.7-23.94a37.24,37.24,0,0,1,11-3.29c.13,0,1.1-.82,1.22-.9a34.86,34.86,0,0,1,3.47-2.11,30.85,30.85,0,0,1,11.75-3.27c1.25-.1,10.83-.67,10.83,1.18,0,.42-.95.64-1.23.74-1,.32-2.07.54-3.11.77-2.6.55-5.24,1-7.82,1.71-.46.13-.92.24-1.37.4a2.14,2.14,0,0,0-1,.63,4,4,0,0,1,1.08-.22c.42,0,.84,0,1.26-.1s.89-.08,1.33-.1c2.08-.12,4.16-.16,6.24-.16s4.07,0,6.1.21a20.18,20.18,0,0,1,5.69,1.29c2.08.85.26,1.35-.73,1.48a50.13,50.13,0,0,1-5.48.25c-1.35,0-2.7,0-4,.05s-2.57,0-3.85.08a8.35,8.35,0,0,0-2.17.3,8.82,8.82,0,0,0,1.53.69c.51.24,1,.49,1.52.75,1,.53,2,1.1,3,1.71l.16.09c.78.49,1.55,1,2.3,1.55,14.14,10.1,15.49,27.61,16.16,35S184.23,338,184.23,338,190.29,414.73,187.6,437Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow-2",
    "data-name": "shadow",
    className: "cls-31",
    d: "M79.29,434.91a15.17,15.17,0,0,0-3.53,15.38,10.45,10.45,0,0,0,3.94,5.28,11.11,11.11,0,0,0,6.43,2,2.44,2.44,0,0,1-1.27-1.76c-.52-2.24-.21-4.52-.24-6.79s-.87-3.84-1.41-5.92A38,38,0,0,1,82,432.56,15.76,15.76,0,0,0,79.29,434.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow-3",
    "data-name": "shadow",
    className: "cls-31",
    d: "M114.43,454.82a26.81,26.81,0,0,1-9.45,7.35c-.12-3.34-.22-6.64-.28-9.65,0-.34,0-.67,0-1,6.75-3.54,8.81-10.78,8.16-17.26-.67-6.73-4.71-16.16-6.06-26.93a37.58,37.58,0,0,1-.09-8.28,42.07,42.07,0,0,1,1.37-7.21,15.31,15.31,0,0,1,1.45-3.89c-.08.7-.15,1.39-.16,2.09a77.88,77.88,0,0,0,1.25,17.31A138.74,138.74,0,0,0,115.5,424C119,434.06,121.92,445.73,114.43,454.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arm-2",
    "data-name": "arm",
    className: "cls-33",
    d: "M105.26,325.33S106.78,346,94,354.12s-20.88,22.9-22.23,35,3.37,28.29,5.39,35.7,5.39,21.55,5.39,21.55-3.37.67-2.7,6.06,3.37,5.39,8.76,5.39c0,0,10.77-.68,18.18-6.06s6.74-18.86,4.72-24.25c0,0-10.11-22.23-2-40.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "belly",
    className: "cls-34",
    x: 131.7,
    y: 351.43,
    width: 49.84,
    height: 89.57,
    rx: 13.47
  }), /*#__PURE__*/React.createElement("g", {
    id: "smile"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 154.6,
    cy: 318.09,
    rx: 20.88,
    ry: 11.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M140.38,315.05a33.72,33.72,0,0,0,28.54-.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "boots"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 148.54,
    y: 515.76,
    width: 59.27,
    height: 4.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 94.66,
    y: 515.76,
    width: 48.49,
    height: 4.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M141.69,486.57,129,486.8l-.07-.06a10.47,10.47,0,0,0-10.06-7.34h-7.21a5.73,5.73,0,0,0-5.79,6l.13,2.49C104.48,494,98,505.73,96,509a10.34,10.34,0,0,0-1.35,6.74h48.49v-8.09C143.15,504.31,141.69,486.57,141.69,486.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M191.64,498.92c-2.83-.57-5.11-2.84-7.06-4.83-2.47-2.51-3.21-6-3.32-9.52v-2.19c0-.33,0-.65,0-1h-4.78a8.42,8.42,0,0,0-7.85,5.39H149.81a167,167,0,0,0-1.27,29H207.8C207.13,500.94,195,499.59,191.64,498.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 162.01,
    cy: 501.61,
    r: 6.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 133.72,
    cy: 502.29,
    rx: 3.37,
    ry: 6.73
  })), /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 139.11,
    y: 289.47,
    width: 5.39,
    height: 10.78,
    rx: 2.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 166.05,
    y: 289.47,
    width: 5.39,
    height: 10.78,
    rx: 2.69
  })), /*#__PURE__*/React.createElement("path", {
    id: "shadow-4",
    "data-name": "shadow",
    className: "cls-31",
    d: "M167.4,454.47s-14.22,8.08-17.89,18.18l-.3-14.14S161.33,457.84,167.4,454.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "detail"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M251.83,348a19,19,0,0,1,5.82-8.33c1-.84-.44-2.26-1.43-1.43a20.83,20.83,0,0,0-6.34,9.22c-.43,1.23,1.52,1.76,2,.54Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "robot"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "neck",
    className: "cls-39",
    x: 460.72,
    y: 354.96,
    width: 25.22,
    height: 7.08,
    transform: "translate(946.66 717.01) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arm-3",
    "data-name": "arm"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arm_l",
    "data-name": "arm l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M420.16,429a7.58,7.58,0,0,0,7.5-.61c23.32-16,25.86-49.78,26-51.21a7.57,7.57,0,0,0-15.1-1c0,.44-2.25,28-19.42,39.77A7.57,7.57,0,0,0,420.16,429Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 400.4,
    y: 417.15,
    width: 21.52,
    height: 21.52,
    rx: 5.23,
    transform: "translate(601.51 -134.16) rotate(62.57)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 464.65,
    y: 302.52,
    width: 31.6,
    height: 52.66,
    rx: 3.15,
    transform: "translate(960.91 657.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 450.41,
    y: 302.52,
    width: 31.6,
    height: 52.75,
    rx: 3.16,
    transform: "translate(932.42 657.78) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glasses"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 442.21,
    y: 316.33,
    width: 46.45,
    height: 5.53,
    rx: 2.76,
    transform: "translate(930.86 638.19) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M471.45,333.77h8.33A3.26,3.26,0,0,0,483,331.1L485,320H466.21l2,11.14A3.26,3.26,0,0,0,471.45,333.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M450.91,333.77h8.33a3.25,3.25,0,0,0,3.2-2.67l2-11.14H445.66l2,11.14A3.25,3.25,0,0,0,450.91,333.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M451.43,331.18h7.29a1.52,1.52,0,0,0,1.5-1.29l1.41-9.42H448.51l1.42,9.42A1.52,1.52,0,0,0,451.43,331.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 446.42,
    y: 322.46,
    width: 17.9,
    height: 4.75,
    transform: "translate(603.72 864.17) rotate(-140.88)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M472,331.18h7.29a1.52,1.52,0,0,0,1.5-1.29l1.42-9.42H469.06l1.42,9.42A1.51,1.51,0,0,0,472,331.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 466.69,
    y: 322.46,
    width: 17.9,
    height: 4.75,
    transform: "translate(639.7 876.95) rotate(-140.88)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "leg",
    className: "cls-40",
    d: "M466.23,504.88l-14.14,3.44a167.91,167.91,0,0,1,0-77.29l14.14,3.44A152.83,152.83,0,0,0,466.23,504.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "boot"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M464.77,497.65s2.58,9.1,2.69,10.67,0,11.68,0,11.68H428.72s-1.91-10.11,8.42-11.68,11.84-6,12.1-9.5a30.1,30.1,0,0,0,0-5.43s4.41-1,5.64,1c.37.6.69,1.14.95,1.62a3.51,3.51,0,0,0,3.16,1.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 428.58,
    y: 516.07,
    width: 38.93,
    height: 3.93
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 460.53,
    cy: 509.52,
    r: 3.74
  })), /*#__PURE__*/React.createElement("path", {
    id: "leg-2",
    "data-name": "leg",
    className: "cls-40",
    d: "M499.35,504.88l-14.13,3.44a167.91,167.91,0,0,1,0-77.29l14.13,3.44A152.83,152.83,0,0,0,499.35,504.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "boot-2",
    "data-name": "boot"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M497.69,497.66a.27.27,0,0,1,.26.19c.37,1.31,2.53,9,2.64,10.47s0,11.68,0,11.68H461.85s-1.91-10.11,8.42-11.68,11.84-6,12.1-9.5a30.1,30.1,0,0,0,0-5.43s4.4-1,5.64,1c.37.6.68,1.15.95,1.62a3.51,3.51,0,0,0,3.15,1.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M497.89,497.65s2.58,9.1,2.7,10.67,0,11.68,0,11.68H461.85s-1.91-10.11,8.42-11.68,11.84-6,12.1-9.5a30.1,30.1,0,0,0,0-5.43s4.4-1,5.64,1c.37.6.68,1.14.95,1.62a3.51,3.51,0,0,0,3.15,1.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 461.71,
    y: 516.07,
    width: 38.93,
    height: 3.93
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 493.66,
    cy: 509.52,
    r: 3.74
  })), /*#__PURE__*/React.createElement("g", {
    id: "torso"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 456.28,
    y: 361.72,
    width: 53.52,
    height: 79.81,
    rx: 6.06,
    transform: "matrix(-1, 0, 0, -1, 964.42, 805.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 436.86,
    y: 361.57,
    width: 53.52,
    height: 79.96,
    rx: 6.07,
    transform: "translate(925.59 805.02) rotate(-179.76)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "details",
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 454.38,
    y1: 377.55,
    x2: 454.38,
    y2: 392.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 449.61,
    y1: 377.55,
    x2: 449.61,
    y2: 392.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 444.84,
    y1: 377.55,
    x2: 444.84,
    y2: 392.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-59",
    cx: 460.34,
    cy: 378.09,
    r: 1.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 460.34,
    cy: 383.94,
    r: 1.63
  })), /*#__PURE__*/React.createElement("g", {
    id: "arm_l-2",
    "data-name": "arm l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M523.63,431.83a7.55,7.55,0,0,0,4.67-5.9c4.18-28-18.83-52.84-19.82-53.89a7.57,7.57,0,0,0-11,10.35c.3.32,19,20.71,15.89,41.3a7.55,7.55,0,0,0,10.3,8.14Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "hand",
    className: "cls-41",
    x: 505.98,
    y: 426.96,
    width: 21.52,
    height: 21.52,
    rx: 5.23,
    transform: "translate(135.79 -122.19) rotate(15.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "girl"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "leg-3",
    "data-name": "leg",
    className: "cls-61",
    x: 350.31,
    y: 372.8,
    width: 11.23,
    height: 10.05,
    transform: "matrix(0.96, -0.28, 0.28, 0.96, -92.38, 116.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-2",
    "data-name": "hand",
    className: "cls-3",
    d: "M291.05,206.2A17,17,0,0,1,291,201a17,17,0,0,0-.1-5.38c-.52-2-1.12-4-1.67-6-.24-.88-.63-4.34-1.82-4.53-.33-.05-.6.24-.77.53-.75,1.26-.32,2.23-.17,3.55a60,60,0,0,1,.41,6.57c0,1.35.26,3.18-1,4l-1.19-3.84a1.4,1.4,0,0,0-2.73.57l.35,3.2c.27,2.46.37,6.1,2.35,7.9a9.06,9.06,0,0,1,1.33,2.91l5.38-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-3",
    "data-name": "hand",
    className: "cls-3",
    d: "M274.58,252.35a17,17,0,0,0-5.23-.13,16.93,16.93,0,0,1-5.37-.17c-2-.54-4-1.16-5.94-1.73-.87-.25-4.33-.69-4.5-1.88,0-.32.25-.6.53-.76,1.27-.73,2.24-.3,3.56-.13a62.73,62.73,0,0,0,6.56.49c1.36,0,3.18.29,4-1l-3.83-1.23a1.4,1.4,0,0,1,.6-2.72l3.2.38c2.45.3,6.09.44,7.86,2.44a9.06,9.06,0,0,0,2.9,1.36l-2.25,5.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arm-4",
    "data-name": "arm"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M340.67,231.73a157.6,157.6,0,0,1-24.54,10.33c-4,1.19-6.63,3.1-10.43,1.24a18,18,0,0,1-5-4.08c-6.14-6.64-14.38-23.7-16.23-27.62a1,1,0,0,1,.35-1.32l6.71-4.7a1.07,1.07,0,0,1,1.48.26c1.38,1.95,5.07,7.17,10.29,14.79a68.77,68.77,0,0,0,4.11,5.52,24.17,24.17,0,0,0,2.73,2.87,2.76,2.76,0,0,0,3,.34c11.85-6.15,19.54-10.86,22.79-12.92.12-.08.24-.16.37-.23A52.26,52.26,0,0,1,340.67,231.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M297.8,242a20.33,20.33,0,0,0,3.55,3.57,25.69,25.69,0,0,0,4.91,2.69c1.11.49,2.62,1.14,3.84.54,2.08-1,2.11-3.65.79-5.25a7.6,7.6,0,0,0-3.44-2,9.87,9.87,0,0,1-3.63-2.21,12.47,12.47,0,0,0-3.31-2.67c-1.66-.74-4.09-.32-4.27,1.82A5.42,5.42,0,0,0,297.8,242Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "foot"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 308.85,
    y: 377.24,
    width: 11.23,
    height: 10.05,
    transform: "translate(-8.82 7.43) rotate(-1.33)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "boot_b",
    "data-name": "boot b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M321.76,403.68l.05,2.07-26.6.62a9.39,9.39,0,0,1-.22-2.06c0-2,.66-4.89,4.18-5.72,5.59-1.31,9.95-4.67,9.38-16.19,0,0,5.29-1.3,4.53,4l7.1-.17a51.36,51.36,0,0,0,1.38,8.84C322.3,397.38,321.76,403.68,321.76,403.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 317.05,
    cy: 398.03,
    r: 2.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 293.83,
    y: 404.03,
    width: 28.35,
    height: 7.15,
    transform: "translate(-9.19 7.11) rotate(-1.3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "leg-4",
    "data-name": "leg"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M307.87,381a1,1,0,0,1-.95-.73c-.68-2.59-1.09-5.32-1.59-7.94q-.93-4.92-1.71-9.87-1.53-9.72-2.49-19.54c-1.9-19.57-.19-38.27,7.57-56.49,1.94-4.57,6.09-14.9,12.29-13.3,4.19,1.07,5.59,6.76,5.82,10.44.69,10.73-.35,21.48-1.75,32.11-.9,6.89-2.12,13.74-2.59,20.67s.26,13.69,1.08,20.55l1.37,11.45c.43,3.57,1.24,7.34,1.38,11a1,1,0,0,1-.89,1C322.09,380.51,310.9,380.88,307.87,381Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 295.33,
    y: 333.68,
    width: 18.35,
    height: 24.1,
    rx: 9.15,
    transform: "translate(-23.2 21.91) rotate(-3.97)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "torso-2",
    "data-name": "torso",
    className: "cls-66",
    d: "M342,289.11l-35.36,3.18c.49-9-.21-17.88-.63-26.91q-.53-11-.28-22.08c0-1.42.08-2.84.12-4.26a62,62,0,0,1,1.57-12.89c2.05-8.1,6.6-14.38,16.61-17.32,1.76-.52,3.53-1.23,5.32-.69l.26.09a8.67,8.67,0,0,1,3.28,2.7,25.52,25.52,0,0,1,3.44,5.28,52.26,52.26,0,0,1,4.37,15.52c.48,3.27.78,6.49,1.05,9.46C342.08,245.22,343.08,289,342,289.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arm-5",
    "data-name": "arm"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M313.6,219.08c-.6,3.81-2.16,12.68-5.4,25.63a2.73,2.73,0,0,1-2.26,2c-1.7.24-4.88.31-10.81-.43-9.17-1.13-15.52-1.82-17.91-2.08a1.07,1.07,0,0,0-1.16.94l-.92,8.14a1.05,1.05,0,0,0,.75,1.14c4.16,1.2,22.4,6.33,31.44,6.12,10.25-.24,10-4.5,12.37-9.69s9.55-24.13,9.64-33.2c.07-6.57-5.94-8.53-10.8-5.81A10,10,0,0,0,313.6,219.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M313,262.91a20.52,20.52,0,0,0,4.34-2.55,24.61,24.61,0,0,0,3.83-4.07c.76-1,1.77-2.26,1.49-3.58-.47-2.28-3-3-4.89-2.08a7.48,7.48,0,0,0-2.75,2.83,9.79,9.79,0,0,1-3.05,3,12.49,12.49,0,0,0-3.41,2.54c-1.14,1.42-1.33,3.88.69,4.59C310.44,264,311.92,263.4,313,262.91Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "badge"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 320.84,
    cy: 222.73,
    r: 4.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 316.88,
    y: 227.65,
    width: 3.74,
    height: 6.05,
    rx: 0.64,
    transform: "translate(21.62 488.6) rotate(-76.85)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair_b",
    "data-name": "hair b",
    className: "cls-70",
    d: "M310.11,202.05s-2.37,8.55-3,10.44l3.66-.85,6.44-8.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mouth",
    className: "cls-71",
    d: "M311.84,193.28c.15,0-.53,1.07-.59,1.15a3,3,0,0,1-3,1c-.55-.06-1.1-.15-1.65-.18-.09,0-1.61-.08-1.46.16,0,0,1,1.63,4.16,1.75s5.26-3.8,5.26-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nose",
    className: "cls-61",
    d: "M307.84,183.55s-2.52,2.65-2.73,3.39.36,1.35,1.3,2.07S307.84,183.55,307.84,183.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face",
    className: "cls-3",
    d: "M308.17,182l-2.53,9.52a.18.18,0,0,0,.11.21,33.45,33.45,0,0,0,8,1.93s-.76,4.85-8.54,1.77c0,0-1,4-.53,5.46s1.39,2.54,5,2.66a31.05,31.05,0,0,1,5.22.48L322,185.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 308.48,
    y: 184.09,
    width: 4.04,
    height: 1.72,
    rx: 0.86,
    transform: "translate(46.2 431.44) rotate(-73.78)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "cls-73",
    d: "M345.85,179.14c.26,5.69.64,11.45-.69,17.05-.54,2.26-1.38,4.74-3.15,6.34-1.61,1.46-3.64,1.58-5.68,1.85-1.65.22-4.28-.38-5.33,1.25a13.51,13.51,0,0,0-.91,2.34c-.8,2.06-2.48,3.06-4.36,3.94-.08-.47-.1-1-.14-1.45-1.22,2.39-3.51,3.27-6.13,3.57l.05-1.3a2.48,2.48,0,0,1-2.69,1.85c-2.29-.09-5.54-.54-6.89.71a38.4,38.4,0,0,1,4.4-12.25c3.51-6.07,6.84-16.08,6.84-16.08s-14.55-4.17-15.49-5.18,0-9.16,4.13-13.58c4.9-5.28,12-5.57,18.47-3.62C335.67,166.82,345.14,170.12,345.85,179.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "boot_b-2",
    "data-name": "boot b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.55,396.6l.59,2-25.52,7.53a9.06,9.06,0,0,1-.75-1.94c-.52-1.94-.64-4.89,2.54-6.61,5.06-2.72,8.39-7.09,4.84-18.07,0,0,4.77-2.64,5.43,2.72l6.8-2a51,51,0,0,0,3.65,8.17C367.43,390.38,368.55,396.6,368.55,396.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M368.55,396.6l.59,2-25.52,7.53a9.06,9.06,0,0,1-.75-1.94c-.52-1.94-.64-4.89,2.54-6.61,5.06-2.72,8.39-7.09,4.84-18.07,0,0,4.77-2.64,5.43,2.72l6.8-2a51,51,0,0,0,3.65,8.17C367.43,390.38,368.55,396.6,368.55,396.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 362.53,
    cy: 392.37,
    r: 2.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 342.12,
    y: 400.4,
    width: 28.35,
    height: 7.15,
    transform: "translate(-99.61 117.12) rotate(-16.41)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "leg-5",
    "data-name": "leg"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M307.41,294.47c0,.29.12.62.22,1a20,20,0,0,0,3.75,7.28c3.89,4.91,10.74,7.41,11.76,14.19a133.2,133.2,0,0,0,7.29,27.22q3.51,9.33,7.59,18.44,2.06,4.63,4.27,9.19c1.17,2.43,2.3,5,3.65,7.34a1,1,0,0,0,1.12.46c2.94-.87,13.77-4.17,16.95-5.3a1,1,0,0,0,.61-1.21c-1.09-3.5-2.88-7-4.24-10.35q-2.17-5.42-4.36-10.82c-2.61-6.48-5.11-12.91-6.47-19.79-1.14-5.71-1.83-11.48-2.54-17.25a322.67,322.67,0,0,0-5.83-35.21c.28,1.16-3.85,3.23-4.65,3.51-2.22.79-4.67,1.14-6.95,1.75a87.21,87.21,0,0,0-11.14,3.73,24.91,24.91,0,0,0-3.51,1.74,14.22,14.22,0,0,1-4.16,1.26C308.17,292.23,307,292.16,307.41,294.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 325.71,
    y: 333.68,
    width: 18.35,
    height: 24.1,
    rx: 9.15,
    transform: "translate(-99.15 137.65) rotate(-20.3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "belt"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 322.65,
    y: 274.51,
    width: 5.3,
    height: 9.27,
    rx: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 311.79,
    y: 274.51,
    width: 5.3,
    height: 9.27,
    rx: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 332.46,
    y: 274.51,
    width: 5.3,
    height: 9.27,
    rx: 1.22
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ladder"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 302.35,
    y: 405.05,
    width: 22.48,
    height: 9.4,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 307.84,
    y: 426.31,
    width: 22.48,
    height: 9.4,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 312.22,
    y: 447.63,
    width: 24.17,
    height: 9.4,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 317.03,
    y: 469.02,
    width: 22.48,
    height: 9.4,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 319.94,
    y: 490.4,
    width: 27.61,
    height: 9.4,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-77",
    x1: 253.23,
    y1: 354.2,
    x2: 294.6,
    y2: 354.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M223.47,514.87,256,335.45a18.23,18.23,0,0,1,17.93-15h0a18.23,18.23,0,0,1,17.93,15l32.51,179.42"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image2.16b9c9bb0803579f503556d0a05eb690.svg";
export { ForwardRef as ReactComponent };